<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()&&!showLoader">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_MOODEL_TEST" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">
                <!-- <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"PART_1_GRAMMAR_VOCABULARY" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.p1Gv}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"PART_2_READING_A" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.p2Ra}}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"PART_2_READING_B" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.p2Rb }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"PART_3_WRITING_A" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.p3Wa }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"PART_3_WRITING_B" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.p3Wb }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"TOTAL" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.moodleTotal }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"STUDENT_LEVEL_WRITING" | translate | titlecase}}</label>
                    <p class="cand-answer">{{moodelData.slWr }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"STUDENT_LEVEL_SPEAKING" | translate | titlecase }}</label>
                    <p class="cand-answer">{{moodelData.slSp }}</p>
                </div> -->
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"CEFR" | translate }}</label>
                    <p class="cand-answer">{{moodelData.cefr }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"RN" | translate | titlecase }}</label>
                    <p class="cand-answer">{{moodelData.rn }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"THANAWEYA_AMA" | translate | titlecase }}</label>
                    <p class="cand-answer">{{moodelData.thanaweya }}</p>
                </div>
                <div class="col-md-4 mb-2" *ngIf="this.moodelData.ieltsFilename!=null && this.moodelData.ieltsFilename !=''">
                    <label class="text-bold font-14">{{"ENGLISH_REPORT" | translate | titlecase }}</label>
                    <!-- <p class="cand-answer">{{moodelData.moodleLink }}</p> -->
                  <p class="cand-answer"><a href="{{moodelData.ieltsFilename }}" target="_blank">{{ "VIEW" |
                            translate | titlecase }}</a></p>
                </div>

            </div>
        </div>
    </div>
</div>
<app-loader [show]="!checkDataExist()"></app-loader>